module.exports = __webpack_public_path__ + "media/icons/loading-9c03950e.png";